import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {throwError, timer} from 'rxjs';
import {catchError, delayWhen, map, retryWhen, tap, timeout} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {SettingsEntry} from '../interfaces/settings-entry';
import { getWsObs } from '../realtime/operators';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(private http: HttpClient) {}

  getServerVersion() {
    return this.http
      .get<SettingsEntry>(
        `${environment.url}/bucket/${environment.buckets.settings}/data/5f53a6d822e159d808bec0fc`
      )
      .pipe(map(setting => setting.value));
  }

  getClientVersion(): string {
    return environment.app_version;
  }

  wsVersion() {
    const url = new URL(`${environment.ws_url}/bucket/${environment.buckets.settings}/data`);
    url.searchParams.set('Authorization', `APIKEY ${environment.apikey}`);

    return getWsObs<SettingsEntry>(url.toString()).pipe(
      // eslint-disable-next-line no-underscore-dangle
      map(settings => settings.find(entry => entry._id === '5f53a6d822e159d808bec0fc'))
    );
  }

  isServerAvailable() {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.settings}/data`).pipe(
      map(res => res),

      retryWhen(errors =>
        errors.pipe(
          //log error message
          tap(val => console.log('server not reachable')),
          //restart in 3 seconds
          delayWhen(val => timer(3000))
        )
      )
    );
  }

  delayAllAppointments(companyId: string, delayValue: string) {
    return this.http.post(`${environment.url}/fn-execute/change-hours`, {
      company_id: companyId,
      hours: delayValue
    });
  }
}
